/**
 * Класс для `ScrollArea`: возвращает внутреннему div вьюпорта Radix блочное поведение.
 *
 * По умолчанию Radix задаёт этому div `display: table` — из-за этого содержимое растягивается
 * по самой длинной строке, а не по ширине области: сокращение и перенос текста не срабатывают,
 * и на узком экране появляется горизонтальная прокрутка вместе с раздутой карточкой.
 */
export const SCROLL_AREA_VIEWPORT_BLOCK = '[&>[data-radix-scroll-area-viewport]>div]:!block';

/**
 * Единый потолок высоты блоков ряда дашборда (рейтинги, критерии, низкие оценки, топ-5 звонков,
 * красные зоны, стабильность, тренды, инсайты) — в пикселях, для блоков, которым высота задаётся
 * значением, а не классом (`DataGrid`).
 *
 * Значение подобрано так, чтобы блок топ-5 звонков помещался целиком: пять карточек звонка
 * с датой, клиентом и обращением укладываются полностью, включая перенос строки на длинных
 * ФИО и обращениях. Прежние 30rem обрезали пятую карточку при переносе описания на вторую строку.
 */
export const DASHBOARD_BLOCK_MAX_HEIGHT = 600;

/**
 * Тот же потолок ({@link DASHBOARD_BLOCK_MAX_HEIGHT}) классом Tailwind: `max-h-150` — это 37.5rem,
 * то есть те же 600 px.
 *
 * Класс и число обязаны совпадать: иначе соседние блоки одного ряда обрываются на разной высоте.
 */
export const DASHBOARD_BLOCK_MAX_HEIGHT_CLASS = 'max-h-150';

/** Потолок блока вместе с прокруткой: не поместившееся прокручивается, не растягивая ряд. */
export const DASHBOARD_BLOCK_SCROLL_CLASS = `${DASHBOARD_BLOCK_MAX_HEIGHT_CLASS} overflow-y-auto`;

/**
 * Прочерк на месте величины, которой нет: пустое значение показывается им везде, где величина
 * выводится текстом (диаграммы, форматтеры порогов, целевых долей и прироста, итог заключения).
 */
export const EMPTY_VALUE = '—';
